/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.15.0
 */

import { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { makeSelectPageOrderIdTranslation } from '../../../../modules/internationalization/intSelectors';
import { initialise, Table, useTableListApi } from '../../../../modules/table';
import { tableIsErrorSelector, tableIsLoadingSelector } from '../../../../modules/table/selectors';
import { stringFormatParams } from '../../../../utils/stringFormat';
import { OrderIdTableColumns } from './OrderIdTableColumns';

export interface IOrderIdSubscriberListProps {
    orderId?: string;
}

const OrderIdTable = ({ orderId }: IOrderIdSubscriberListProps) => {

    const dispatch = useDispatch();

    const translationOrderId = useSelector(makeSelectPageOrderIdTranslation());

    /* Инициализация таблицы */
    useEffect(() => {
        if (!orderId) return;

        dispatch(initialise({
            list: {
                url: stringFormatParams('/order/{orderId}/list', { orderId }),
                disableCheckOnDensity: true,
            },
        }));
    }, [orderId, dispatch]);


    /* Table List */
    const { data, infiniteLoader } = useTableListApi();

    /* Table Statuses  */
    const isLoading = useSelector(tableIsLoadingSelector);
    const isError = useSelector(tableIsErrorSelector);

    /* Table Meta  */
    const columns = useMemo(() => OrderIdTableColumns(
        translationOrderId,
        {
            hasLabels: Object.prototype.hasOwnProperty.call((data[0] || {}), 'label'),
            hasName: Object.prototype.hasOwnProperty.call((data[0] || {}), 'name'),
        },
    ), [translationOrderId, data]);

    return (
        <Table
            columns={columns}
            containerHeight={400}
            data={data}
            dataName="order-id-list"
            dataNameRow="msisdn"
            infiniteScroll={infiniteLoader}
            isError={isError}
            isLoading={isLoading}
        />
    );
};

export default OrderIdTable;
